import styled from "styled-components";

export const Container = styled.div`
    margin-left: 2rem;
    margin-right: 2rem;
`;